import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Link, RouterProvider } from "react-router-dom";
import { Layout } from "./components/pages/layout/Layout";
import router from "./Routes";
import AppRoutes from "./Routes";
import Navigation from "Navigation";
import { useIsAuthenticated, useMsal, useMsalAuthentication, AuthenticatedTemplate, UnauthenticatedTemplate, MsalAuthenticationTemplate } from "@azure/msal-react";
import { AccountInfo, InteractionRequiredAuthError, InteractionStatus, InteractionType, PublicClientApplication } from "@azure/msal-browser";
import { SiteSessionService, StorageLabel } from "./core/services/SiteSessionService";
import { msalConfig, loginRequest } from "./authConfig";
import { msalInstance } from "./index";
import { ErrorComponent } from "./components/common/ErrorComponent";
import { Spinner } from "components/common/Spinner";
import { useStores } from "core/stores";
import { response } from "express";


interface RoutesComponentProps {
    msalInstance: PublicClientApplication;
}

export default function RoutesComponent(props: RoutesComponentProps) {   

    const { accounts } = useMsal();

    const { userStore  } = useStores();
   
    return (
        <>
            <MsalAuthenticationTemplate interactionType={InteractionType.Popup} authenticationRequest={loginRequest} errorComponent={ErrorComponent} loadingComponent={Spinner} >
                <Layout msalInstance={props.msalInstance}>
                    <AppRoutes msalInstance={props.msalInstance} />
                </Layout>
            </MsalAuthenticationTemplate>

            <UnauthenticatedTemplate>
                <div className="d-flex justify-content-center">                   
                </div>
            </UnauthenticatedTemplate>
        </>
    );
}
